import service from "@/api/service";
import { GetResponse } from "@/api/point-detail/response";
import { GetRequest } from "@/api/point-detail/request";

/**
 * ポイントカード詳細情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-point-detail", getRequest);
  return response.data as GetResponse;
}
